import { render, staticRenderFns } from "./courseEvaluationList.vue?vue&type=template&id=68c7923e"
import script from "./courseEvaluationList.vue?vue&type=script&lang=js"
export * from "./courseEvaluationList.vue?vue&type=script&lang=js"
import style0 from "./courseEvaluationList.vue?vue&type=style&index=0&id=68c7923e&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports